import script from "./CapturePhoto.vue?vue&type=script&setup=true&lang=js"
export * from "./CapturePhoto.vue?vue&type=script&setup=true&lang=js"

import "./CapturePhoto.vue?vue&type=style&index=0&id=aacee0fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aacee0fc"]])

export default __exports__